import { FC, useEffect } from "react";
import ToastNotificationInstance from "../ToastNotificationInstance";

const InitMiddleware: FC<{}> = ({}) => {

  return <ToastNotificationInstance />;
};

export default InitMiddleware;
